import type { ICloudStorageHeaders } from '@picsart/cloud-storage/types/core/types/api/headers';

import { getContext } from '@/context';
import { getAppStore } from '@/store';
import { ToastType } from '@/store/toast/types';

export const getCloudStorageHeaders = (): ICloudStorageHeaders => {
  return getContext().utils.api.getHeaders() as ICloudStorageHeaders;
};

interface CloudStorageErrorHandlingParams<T> {
  operation: () => Promise<T>;
  errorMessage: string;
}

export const withCloudStorageErrorHandling = async <T>({
  operation,
  errorMessage,
}: CloudStorageErrorHandlingParams<T>): Promise<T | null> => {
  try {
    return await operation();
  } catch {
    getAppStore().showToast(errorMessage, ToastType.Error);
    return null;
  }
};
